// const BASE_URL = 'https://project-sos.herokuapp.com';
// const BASE_URL = 'https://api.sos.dev.stickboy.co';
const BASE_URL = 'https://api.sos.prod.stickboy.co';

export default {
  BASE_URL,
};
